export default __webpack_public_path__ + "assets/icons/picking.70140978.svg";